 
export const checkFolderConnection = async (folderId: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/panopto/check-folder-connection`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      folder_id: folderId
    })
  });
  return await response.json();
};

export const fetchPanoptoSessions = async (folderId: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/panopto/sessions/${folderId}`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return await response.json();
};

export const fetchPanoptoSessionsStub = async (folderId: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/panopto/sessionstub`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return await response.json();
};
